import { render, staticRenderFns } from "./productLabelManage.vue?vue&type=template&id=a91f34ea&scoped=true"
import script from "./productLabelManage.vue?vue&type=script&lang=js"
export * from "./productLabelManage.vue?vue&type=script&lang=js"
import style0 from "./productLabelManage.vue?vue&type=style&index=0&id=a91f34ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91f34ea",
  null
  
)

export default component.exports